import React from 'react';
import { createPortal } from 'react-dom';
import './AboutModal.css';

function AboutModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  const modalContent = (
    <div className="about-modal-backdrop" onClick={handleBackdropClick}>
      <div className="about-modal">
        <button
          type="button"
          className="about-modal-close text-non-selectable"
          onClick={onClose}
          aria-label="Close about"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4 L4 12 M4 4 L12 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </button>
        <div className="about-modal-logo">
          <svg width="130" height="40" viewBox="0 0 130 40" xmlns="http://www.w3.org/2000/svg">
            <text x="10" y="28" fontFamily="system-ui, -apple-system, sans-serif" fontSize="24" fontWeight="600">
              <tspan fill="#444" fontSize="24">pico</tspan><tspan fill="#333" fontSize="28" dx="1">todo</tspan>
            </text>
          </svg>
        </div>
        <p className="about-modal-contact">Contact: info@picotodo.com</p>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
}

export default AboutModal;
